<template>
  <v-card
    flat
    v-scroll.self="onScroll"
    :class="scrollClass"
    max-height="276px"
    style="width: 100%"
  >
    <score-leader-board
      v-if="tabSelected === 0"
      :leaderboard="scoreLeaderboard"
      :classScroll="scrollClass"
    />
    <time-leader-board
      v-if="tabSelected === 1"
      :leaderboard="timeLeaderboard"
      :classScroll="scrollClass"
    />
  </v-card>
</template>

<script>
import Avatar from 'vue-avatar'
import { getDuration, roundToTwo, getLocalDate } from '../Constants'
import moment from 'moment'
import TimeLeaderBoard from './TimeLeaderBoard.vue'
import ScoreLeaderBoard from './ScoreLeaderBoard.vue'

const LEADER_ITEM_SCROLL = 4

export default {
  props: {
    course: {
      type: Object,
      required: false
    },
    agent: {
      type: String,
      required: false,
      default: null
    },
    agentCoursesData: {
      type: Array,
      required: false,
      default: null
    },
    agentName: {
      type: String,
      required: false,
      default: null
    },
    tabSelected: {
      type: Number,
      require: true,
      default: 0
    }
  },
  data: () => ({
    leaderboardData: null,
    loading: false,
    avatarSize: 35,
    scoreClass: 'score-text',
    scrollInvoked: 0,
    scrollClass: 'overflow-y-auto',
    timeLeaderboard: [],
    scoreLeaderboard: []
  }),
  components: {
    TimeLeaderBoard,
    ScoreLeaderBoard
  },
  watch: {
    tabSelected: function(newVal, oldVal) {
      this.fillLeaderboard()
    }
  },
  computed: {
    interactionClass() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
        case 'sm':
          return 'd-none'
          break
        default:
          return 'body-1 font-weight-light'
      }
    }
  },
  methods: {
    onScroll() {
      this.scrollInvoked++
    },
    goToAgent(value) {
      this.$router.push({
        path: `/courses/${this.course.id}?agentId=${
          value.userId
        }&agentName=${encodeURIComponent(value.name)}`
      })
    },
    groupDataByAgent() {
      this.leaderboardData = new Array(
        { name: 'time', data: [] },
        { name: 'score', data: [] }
      )

      if (
        this.agentCoursesData != null &&
        this.agentCoursesData !== undefined
      ) {
        const agentCourses = Object.assign([], this.agentCoursesData)
        agentCourses.forEach(element => {
          if (element.scoreLeaderBoard != null) {
            element.scoreLeaderBoard.forEach(e => {
              e.courseName = element.name
              this.leaderboardData[1].data.push(e)
            })

            element.timeSpentLeaderBoard.forEach(e => {
              // if exist add to it
              if (e.timeSpent) {
                let timeEle = _.find(this.leaderboardData[0].data, {
                  name: e.name
                })

                if (timeEle) {
                  timeEle.interactionsCount += e.interactionsCount
                  timeEle.timeSpent = moment
                    .duration(timeEle.timeSpent)
                    .add(e.timeSpent)
                } else {
                  this.leaderboardData[0].data.push(Object.assign({}, e))
                }
              }
            })
          }
        })
      } else {
        let leaderboard = new Array(
          { name: 'time', interactions: [] },
          { name: 'score', interactions: [] }
        )

        if (
          this.course.interactions != null &&
          this.course.interactions !== undefined
        ) {
          const sectionData = new Array()
          const coursesInt = Object.assign([], this.course.interactions)
          coursesInt.forEach(element => {
            if (element.duration != null && element.duration !== undefined) {
              element.duration = getDuration(element.duration)
            }

            leaderboard[0].interactions.push(element)

            if (
              (element.verb === 'failed' ||
                element.verb === 'passed' ||
                element.verb === 'completed') &&
              element.score != null &&
              element.score !== undefined
            ) {
              leaderboard[1].interactions.push(element)
            }
          })

          this.leaderboardData[1].data = leaderboard[1].interactions
          this.leaderboardData[0].data = _.chain(leaderboard[0].interactions)
            // Group the elements of Array based on `name` property
            .groupBy('name')
            // `key` is group's name (name), `value` is the array of interactions
            .map((value, key) => ({ name: key, interactions: value }))
            .value()
        }
      }
    },
    fillTimeSpentLeaderboard() {
      this.scoreLeaderboard = []
      this.timeLeaderboard = []
      let bgColor = 'black--text'
      this.leaderboardData[0].data.forEach(element => {
        let intCount = 0
        let timeSpent = null
        let userId = null

        if (
          this.agentCoursesData != null &&
          this.agentCoursesData !== undefined
        ) {
          bgColor =
            element.name === this.agentName ? 'red--text' : 'black--text'
          intCount = element.interactionsCount
          if (timeSpent == null) {
            timeSpent = moment.duration(element.timeSpent)
          } else {
            timeSpent = moment.duration(element.timeSpent).add(timeSpent)
          }
        } else {
          if (this.agent != null) {
            bgColor =
              element.userId === parseInt(this.agent)
                ? 'red--text'
                : 'black--text'
          }
          element.interactions.forEach(ele => {
            userId = ele.userId
            intCount++
            if (ele.score == null && ele.score === undefined) {
              if (timeSpent == null) {
                timeSpent = moment.duration(ele.duration)
              } else {
                timeSpent = moment.duration(ele.duration).add(timeSpent)
              }
            }
          })
        }
        this.timeLeaderboard.push({
          name: element.name,
          userId: userId,
          score: null,
          interactions: intCount,
          timeSpent: getDuration(timeSpent),
          color: bgColor,
          scoreColor: ''
        })
      })
      this.timeLeaderboard = _.orderBy(
        this.timeLeaderboard,
        ['timeSpent'],
        ['desc']
      )

      this.scrollClass =
        this.timeLeaderboard.length > LEADER_ITEM_SCROLL
          ? 'overflow-y-auto'
          : ''
    },
    fillScoreLeaderboard() {
      let bgColor = 'black--text'
      this.timeLeaderboard = []
      this.scoreLeaderboard = []
      this.leaderboardData[1].data.forEach(element => {
        let score = 0
        let scoreCount = 0
        let timeSpent = null
        let userId = null
        let courseName = null

        if (
          this.agentCoursesData != null &&
          this.agentCoursesData !== undefined
        ) {
          bgColor =
            element.name === this.agentName ? 'red--text' : 'black--text'

          scoreCount = element.scoreCount
          score = parseFloat(element.score)
          if (element.courseName) {
            courseName = element.courseName
          }
        } else {
          userId = element.userId
          score = parseFloat(element.score)
          scoreCount++
          timeSpent = element.duration
        }
        let finalScore = roundToTwo(score)
        const scoreColor =
          (finalScore !== '' && finalScore >= 75) || element.verb === 'passed'
            ? 'score-text'
            : 'score-text-failed'
        let date = getLocalDate(element.timestamp)
        this.scoreLeaderboard.push({
          name: element.name,
          userId: userId,
          score: finalScore,
          interactions: 0,
          timeSpent: getDuration(timeSpent),
          color: bgColor,
          scoreColor: scoreColor,
          date: moment(date).format('MMM D, YYYY'),
          time: moment(date).format('h:mm A'),
          courseName: courseName
        })
      })

      this.scoreLeaderboard = _.orderBy(
        this.scoreLeaderboard,
        ['score'],
        ['desc']
      )
      this.scrollClass =
        this.scoreLeaderboard.length > LEADER_ITEM_SCROLL
          ? 'overflow-y-auto'
          : ''
    },
    fillLeaderboard() {
      if (this.tabSelected === 0) {
        this.fillScoreLeaderboard()
      } else if (this.tabSelected === 1) {
        this.fillTimeSpentLeaderboard()
      }
    }
  },
  mounted() {
    this.loading = true
    this.groupDataByAgent()
    this.fillLeaderboard()
    this.loading = false
  }
}
</script>

<style>
.my-border {
  border-style: solid;
}
.score-text {
  color: #7ed321;
}
.score-text-failed {
  color: #f5a623;
}
.time-spent-text {
  color: #75b9be;
}
.interactions-text-label {
  font-size: 0.8em;
  color: gray;
  text-align: center;
}
.interactions-text-value {
  font-size: 0.9em;
  color: gray;
  font-weight: bold;
  text-align: center;
}

.course-text-label {
  font-size: 0.7em;
  color: gray;
  text-align: center;
}
.course-text-value {
  font-size: 0.6em;
  color: gray;
  font-weight: bold;
  text-align: center;
}
</style>
